<header [class.scrolled]="isScrolled">
  <div class="row align-items-center mx-0">
    <!-- Logo -->
    <div class="col-6 col-lg-5 px-0">
      <img src="assets/img/shared/alamat-logo-white.png" alt="" class="logo">
    </div>

    <!-- Hamburger Menu (Mobile Only) -->
    <div class="col-7 d-lg-none text-right px-0" *ngIf="!isIntroductionPage">
      <button class="hamburger" [class.active]="isMenuOpen" (click)="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Desktop Navigation -->
    <div class="col-lg-7 d-none d-lg-flex desktop-nav px-0">
      <div class="nav-container">
        <button class="nav" [class.active]="activeTab === 'introduction'" (click)="navigateTo('/home')">
        <!-- <button class="nav" [class.active]="activeTab === 'introduction'" (click)="navigateTo('/introduction')"> -->
          <a class="t-fs16">Introduction</a>
        </button>

        <!-- Introduction Page Specific Tabs (Desktop) -->
        <ng-container *ngIf="isIntroductionPage">
          <button class="nav" (click)="scrollToSection('how-to-play-section')" [class.active]="activeSection === 'how-to-play-section'">
            <a class="t-fs16">How to Play</a>
          </button>
          <button class="nav" (click)="scrollToSection('how-to-score-section')" [class.active]="activeSection === 'how-to-score-section'">
            <a class="t-fs16">How to Score</a>
          </button>
          <button class="nav" (click)="scrollToSection('footer')" [class.active]="activeSection === 'footer'">
            <a class="t-fs16">Contact Us</a>
          </button>


          
          <!-- Registration Dropdown -->
          <div ngbDropdown class="dropdown nav" 
               (mouseenter)="onMouseEnterRegistration()" 
               (mouseleave)="onMouseLeaveRegistration()"
               [class.show]="showRegistrationDropdown">
            <button ngbDropdownToggle class="btn nav" id="registrationDropdown" 
                    [class.active]="activeTab === 'registration'"
                    (click)="toggleRegistrationDropdown($event)">
              <span class="t-fs16">Registration</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="registrationDropdown" class="dropdown-menu" 
                 [class.show]="showRegistrationDropdown">
              <button ngbDropdownItem *ngFor="let option of registrationOptions" 
                      (click)="navigateTo(option.path)">
                <a class="t-fs16">{{option.name}}</a>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isIntroductionPage">
          <!-- HOME TAB HIDDEN -->
          <!-- <button class="nav" [class.active]="activeTab === 'home'" (click)="navigateTo('/introduction')"> -->
          <!-- <button class="nav" [class.active]="activeTab === 'home'" (click)="navigateTo('/home')"> -->
            <!-- <a class="t-fs16">Home</a>
          </button> -->
          
          <!-- Gameplay Dropdown HIDDEN-->
          <!-- <div ngbDropdown class="dropdown nav" 
               (mouseenter)="onMouseEnterGameplay()" 
               (mouseleave)="onMouseLeaveGameplay()"
               [class.show]="showGameplayDropdown">
            <button ngbDropdownToggle class="btn nav" id="gameplayDropdown" 
                    [class.active]="activeTab === 'gameplay' || isGameplayActive()"
                    (click)="toggleGameplayDropdown($event); !isMobileView && navigateToFirstGameplay()">
              <span class="t-fs16">Gameplay</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="gameplayDropdown" class="dropdown-menu" 
                 [class.show]="showGameplayDropdown">
              <button ngbDropdownItem *ngFor="let option of gameplayOptions" 
                      (click)="navigateTo(option.path)">
                <a class="t-fs16">{{option.name}}</a>
              </button>
            </div>
          </div> -->

          <!-- CARDS TAB HIDDEN -->
          <!-- <button class="nav" [class.active]="activeTab === 'cards'" (click)="navigateTo('/cards')">
            <a class="t-fs16">Cards</a>
          </button> -->
          
          <button class="nav" [class.active]="activeTab === 'ranking'" (click)="navigateTo('/ranking')">
            <a class="t-fs16">Ranking</a>
          </button>
          
          <button class="nav" [class.active]="activeTab === 'statistics'" (click)="navigateTo('/statistics')">
            <a class="t-fs16">Statistics</a>
          </button>
          
          <button class="nav" [class.active]="activeTab === 'tournaments'" (click)="navigateTo('/tournaments')">
            <a class="t-fs16">Tournaments</a>
          </button>
          
          <!-- Registration Dropdown -->
          <div ngbDropdown class="dropdown nav" 
               (mouseenter)="onMouseEnterRegistration()" 
               (mouseleave)="onMouseLeaveRegistration()"
               [class.show]="showRegistrationDropdown">
            <button ngbDropdownToggle class="btn nav" id="registrationDropdown" 
                    [class.active]="activeTab === 'registration'"
                    (click)="toggleRegistrationDropdown($event)">
              <span class="t-fs16">Registration</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="registrationDropdown" class="dropdown-menu" 
                 [class.show]="showRegistrationDropdown">
              <button ngbDropdownItem *ngFor="let option of registrationOptions" 
                      (click)="navigateTo(option.path)">
                <a class="t-fs16">{{option.name}}</a>
              </button>
            </div>
          </div>
          
          <!-- Manual Dropdown HIDDEN-->
          <!-- <div ngbDropdown class="dropdown nav" 
               (mouseenter)="onMouseEnterManual()" 
               (mouseleave)="onMouseLeaveManual()"
               [class.show]="showManualDropdown">
            <button ngbDropdownToggle class="btn nav" id="manualDropdown" 
                    [class.active]="activeTab === 'manual' || isManualActive()"
                    (click)="toggleManualDropdown($event); !isMobileView && navigateToFirstManual()">
              <span class="t-fs16">Manual</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="manualDropdown" class="dropdown-menu t-fs16"
                 [class.show]="showManualDropdown">
              <button ngbDropdownItem *ngFor="let option of manualOptions" class="t-fs16"
                      (click)="option.children ? showAbilities = !showAbilities : navigateTo(option.path)">
                <a *ngIf="!option.children" (click)="navigateTo(option.path)">{{option.name}}</a>
                
                 <Abilities with submenu> --COMMENT 
                <div *ngIf="option.children" class="submenu-container" 
                     (mouseenter)="showAbilities = true" 
                     (mouseleave)="showAbilities = false">
                  <button class="submenu-trigger">
                    {{option.name}}
                    <span class="submenu-indicator">›</span>
                  </button>
                  <div class="submenu" [class.show]="showAbilities">
                    <a *ngFor="let child of option.children" 
                       (click)="navigateTo(child.path)" 
                       class="t-fs16 submenu-item">
                      {{child.name}}
                    </a>
                  </div>
                </div>
              </button>
            </div>
          </div> -->

          <!-- CONTAACT US HIDDEN -->
          <!-- <button class="nav" [class.active]="activeTab === 'contactus'" (click)="navigateTo('/contactus')">
            <a class="t-fs16">Contact Us</a>
          </button> -->
          
          <!-- Logout Button -->
          <button class="nav logout-nav" *ngIf="deckService.isLoggedIn()" (click)="logout()">
            <a class="t-fs16">Logout</a>
          </button>
        </ng-container>
      </div>
    </div>

    <!-- Mobile Navigation (Regular Pages) -->
    <div class="col-12 mobile-nav px-0" [class.active]="isMenuOpen" *ngIf="!isIntroductionPage">
      <div class="mobile-menu-container">
        <button class="nav-mobile" [class.active]="activeTab === 'home'" (click)="navigateTo('/home')">
          <a>Home</a>
        </button>

        <div class="mobile-dropdown">
          <button class="mobile-menu-item" (click)="toggleSubmenu('gameplay')">
            Gameplay <span class="arrow" [class.rotated]="openSubmenu === 'gameplay'">›</span>
          </button>
          <div class="mobile-submenu" [class.open]="openSubmenu === 'gameplay'">
            <a *ngFor="let option of gameplayOptions" 
               (click)="navigateTo(option.path)" 
               class="nav-mobile">
              {{option.name}}
            </a>
          </div>
        </div>

        <button class="nav-mobile" [class.active]="activeTab === 'cards'" (click)="navigateTo('/cards')">
          <a>Cards</a>
        </button>

        <button class="nav-mobile" [class.active]="activeTab === 'ranking'" (click)="navigateTo('/ranking')">
          <a>Ranking</a>
        </button>

        <button class="nav-mobile" [class.active]="activeTab === 'statistics'" (click)="navigateTo('/statistics')">
          <a>Statistics</a>
        </button>

        <button class="nav-mobile" [class.active]="activeTab === 'tournaments'" (click)="navigateTo('/tournaments')">
          <a>Tournaments</a>
        </button>

        <div class="mobile-dropdown">
          <button class="mobile-menu-item" (click)="toggleSubmenu('registration')">
            Registration <span class="arrow" [class.rotated]="openSubmenu === 'registration'">›</span>
          </button>
          <div class="mobile-submenu" [class.open]="openSubmenu === 'registration'">
            <a *ngFor="let option of registrationOptions" 
               (click)="navigateTo(option.path)" 
               class="nav-mobile">
              {{option.name}}
            </a>
          </div>
        </div>

        <div class="mobile-dropdown">
          <button class="mobile-menu-item" (click)="toggleSubmenu('manual')">
            Manual <span class="arrow" [class.rotated]="openSubmenu === 'manual'">›</span>
          </button>
          <div class="mobile-submenu" [class.open]="openSubmenu === 'manual'">
            <ng-container *ngFor="let option of manualOptions">
              <a *ngIf="!option.children"
                 (click)="navigateTo(option.path)" 
                 class="nav-mobile">
                {{option.name}}
              </a>
            </ng-container>
            <div>
              <button class="mobile-menu-item submenu-trigger" (click)="showAbilitiesMobile = !showAbilitiesMobile">
                Abilities <span class="arrow" [class.rotated]="showAbilitiesMobile">›</span>
              </button>
              <div class="mobile-submenu" [class.open]="showAbilitiesMobile">
                <a *ngFor="let ability of getAbilitiesOptions()" 
                   (click)="navigateTo(ability.path)" 
                   class="nav-mobile sub-item">
                  {{ability.name}}
                </a>
              </div>
            </div>
          </div>
        </div>

        <button class="nav-mobile" [class.active]="activeTab === 'contactus'" (click)="navigateTo('/contactus')">
          <a>Contact Us</a>
        </button>

        <button class="nav-mobile logout-mobile" *ngIf="deckService.isLoggedIn()" (click)="logout()">
          <a>Logout</a>
        </button>
      </div>
    </div>

    <!-- Mobile Navigation (Introduction Page) -->
    <div class="col-12 mobile-nav px-0" [class.active]="isMenuOpen" *ngIf="isIntroductionPage">
      <div class="mobile-menu-container">
        <button class="nav-mobile" [class.active]="activeTab === 'introduction'" (click)="navigateTo('/introduction')">
          <a>Introduction</a>
        </button>
        <button class="nav-mobile" (click)="scrollToSection('how-to-play-section')">
          <a>How to Play</a>
        </button>
        <button class="nav-mobile" (click)="scrollToSection('how-to-score-section')">
          <a>How to Score</a>
        </button>
        <button class="nav-mobile" (click)="scrollToSection('footer')">
          <a>Contact Us</a>
        </button>
      </div>
    </div>
  </div>
</header>